<app-section>
    <div class="test-question" [@fadeSlide]>
        <div class="test-question__number notranslate" >
            Pregunta {{ currentIndex + 1 }} de {{ test.questions.length }}
        </div>

        <div class="test-question__text notranslate">
            {{ currentQuestion.question }}
        </div>

        <div class="test-question__options">
            <label class="test-question__option" *ngFor="let opt of shuffledOptions"
                [class.test-question__option--selected]="isOptionSelected(opt._id)">
                <input type="radio" name="option" [value]="opt._id" [checked]="isOptionSelected(opt._id)"
                    (change)="selectOption(opt._id)" />
                {{ opt.option }}
            </label>
        </div>

        <div class="test-question__footer">
            <app-button variant="primary" (onClick)="next()" [disabled]="!isCurrentAnswered()" size="lg">
                {{ currentIndex + 1 === test.questions.length ? 'Finalizar' : 'Siguiente' }}
            </app-button>
        </div>
    </div>

</app-section>